import LoginForm from "../../components/User/LoginForm";
import Layout from "../../layout/Layout";

export default function Login() {
  return (
      <LoginForm />
  );
}
